import React, { Component, MouseEvent } from "react";
import cover from './Images/starting-page.jpeg';

type StartPageProps = {
    /// asks parent to begin quiz
    onStartClick: () => void;
}

export class StartPage extends Component<StartPageProps> {
    render = (): JSX.Element => {
        return (
            <div className="start">
                <h1>Which color are you based on the vacation you plan?</h1>
                <img src={cover} className="final" alt="cover"/>
                <p></p>
                <button type="button" onClick={this.doStartClick}>Start Quiz</button>
            </div>
        );
    }

    // Updates UI to quiz page
    doStartClick = (_evt: MouseEvent<HTMLButtonElement>): void => {
        this.props.onStartClick();
    }
}